<footer id="footer" class="main-footer">
    <div class="container" *ngIf="pageData">
        <ul>
            <li *ngFor="let link of footerLinks">
                <a *ngIf="link.uiSref" rel="noopener" target="_blank" [uiSref]="link.uiSref">{{ link.text }}</a>
                <a *ngIf="link.href" rel="noopener" target="_blank" href="{{ link.href }}">{{ link.text }}</a>
                <xm-media-image *ngIf="link.icon" size="width" [imageOptions]="buildIcon(link.icon)"></xm-media-image>
            </li>
            <li *ngIf="pageData.englishText && pageData.spanishText && !isBusinessUser">
                <button class="letzchat" (click)="onLanguageChange('en')">{{ pageData.englishText }}</button>
                <span> | </span>
                <button class="letzchat" (click)="onLanguageChange('es')">{{ pageData.spanishText }}</button>
            </li>
        </ul>
        <p class="footer-copyright-text">{{ this.copyrightText }}</p>
    </div>
</footer>
